<template>
  <v-card flat height="100%">
    <v-card 
      flat 
      class="text-center" 
      :loading="loading"
    >
      <v-card-text>
        <span class="text-h6 font-weight-bold">
          Bảng giá khác
        </span> 
      </v-card-text>
    </v-card>
    <v-card 
      v-if="items.length == 0"
      flat 
      class="text-center" 
      height="100%"
    >
      <v-card-text>
        <span>
          Không tìm thấy bảng giá liên quan
        </span>
      </v-card-text>
    </v-card>
    <div 
      v-for="(date, i) in items" 
      :key="`other_price${i}`"
      class="px-6"
    >
      <v-card flat
        :to="{ name: 'MarketView', params: { date: parseDate(date.ngay_cap_nhat) }}"
        class="mrelated">
        <div class="d-flex flex-no-wrap">
          <div class="ma-3 rounded-lg thumb">
            <div class="thtop">
              <div>{{date.ngay_cap_nhat.split("/")[0]}}Th{{date.ngay_cap_nhat.split("/")[1]}}</div>
            </div>
            <div class="thbot">
              <div>{{date.ngay_cap_nhat.split("/")[2]}}</div>
            </div>
          </div>
          <div>
            <v-card-title class="text-h6">
              Giá cả nông sản, vật tư nông nghiệp
            </v-card-title>
            <v-card-subtitle class="mt-1">
              <v-icon>mdi-calendar</v-icon>
              Lúc: {{date._created_at}}
            </v-card-subtitle>
          </div>
        </div>
      </v-card>
      <v-divider
        v-if="i < date.length - 1"
        :key="i"
        inset
      />
    </div>
  </v-card>
</template>
<script>
export default {
  props: {
    date: {
      type: String
    }
  },
  data: () => ({
    loading: false,
    items: []
  }),
  watch: {
    date(){
      this.getMarketDateRelated();
    }
  },
  mounted () {
    this.getMarketDateRelated();
  },
  methods: {
    getMarketDateRelated(){
      const app = this;
      app.loading = true;
      axios.get(`api/v1/public/get-market-date-related/${this.date}`)
        .then(response => {
          app.items = response.data;
          app.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          app.loading = false;
        });
    },
    parseDate(d){
      // convert to format: ddmmyyyy
      if(!d) return null;
      return d.replaceAll('/', '');
    },
  }
}
</script>